/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartNoShipping_item$ref = any;
type CartPrice_item$ref = any;
export type CartPriceTable_item$ref = any;
export type CartPriceTable_item = {
    readonly isFurniture: boolean | null;
    readonly pricing: {
        readonly purchasable: unknown | null;
    } | null;
    readonly " $fragmentRefs": CartPrice_item$ref & CartNoShipping_item$ref;
    readonly " $refType": CartPriceTable_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartPriceTable_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isFurniture",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "pricing",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemPricing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "purchasable",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "CartPrice_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartNoShipping_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '54801b031b41037e9c930a1bce2d17a2';
export default node;
